module.exports = __webpack_public_path__ + "img/pin-hover.6f0aed9b.svg";